// @flow

import type { BootstrapConfig as BootstrapConfigType } from 'amktBootstrap';

class BootstrapConfig {
  _bootstrapConfig: BootstrapConfigType | {};

  constructor() {
    this._bootstrapConfig = {};
  }

  get(): BootstrapConfigType {
    /* $FlowIgnore The assumption here is that BootstrapConfig.set
       has already been called at app startup, and hence this is
       always defined
     */
    return this._bootstrapConfig;
  }

  set(config: BootstrapConfigType) {
    this._bootstrapConfig = config;
  }
}

export default new BootstrapConfig();
